export default __webpack_public_path__ + "static/media/mesin_anjungan.2c7d630e.png";